import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@flatfile/design-system";
import { useMemo } from "react";
import { Pill, ClipText, RemovePill, PillsWrapper, OptionImage } from "./Styles.js";
const getOptionIcon = (icon) => {
  if (typeof icon === "string") {
    return /* @__PURE__ */ jsx(OptionImage, { url: icon });
  }
  return icon || null;
};
const Pills = ({ allowRemove = true, options, removeItem, editor }) => {
  const handleRemove = (item) => (event) => {
    event == null ? void 0 : event.preventDefault();
    event == null ? void 0 : event.stopPropagation();
    if (removeItem)
      removeItem(item);
  };
  if (!options)
    return null;
  const list = useMemo(() => {
    const single = options.length === 1;
    return options.map((option, index) => {
      const label = `${option.label}`;
      return /* @__PURE__ */ jsxs(
        Pill,
        {
          error: !!option.error,
          warning: !!option.warning,
          single,
          "data-testid": `pill-${index}`,
          className: "turntable-badge",
          children: [
            getOptionIcon(option.icon),
            /* @__PURE__ */ jsx(ClipText, { title: label, children: label }),
            allowRemove && /* @__PURE__ */ jsx(RemovePill, { onClick: handleRemove(option), children: /* @__PURE__ */ jsx(Icon, { name: "cross", size: 16 }) })
          ]
        },
        `${index}:${label}`
      );
    });
  }, [options, allowRemove]);
  return /* @__PURE__ */ jsx(PillsWrapper, { editor, children: list });
};
export {
  Pills
};
